var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 383.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #222121;\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        mix-blend-mode: multiply;\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "easylan"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m101.31,155.79v228.08s-66.69,0-66.69,0v-228.08s-34.62,0-34.62,0v-51.42s34.62,0,34.62,0v-15.78c0-82.98,63.13-88.07,110.99-88.58v51.42c-16.8,0-44.29,0-44.29,39.2v13.75s142.55,0,142.55,0v279.5s-66.69,0-66.69,0v-228.08s-75.86,0-75.86,0Zm75.86-89.09V7.13s66.69,0,66.69,0v59.57s-66.69,0-66.69,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m374.2,236.73l-94.18-132.37h80.44s54.48,86.04,54.48,86.04l54.48-86.04h79.42s-93.67,132.37-93.67,132.37l104.36,147.13h-81.96s-62.62-96.22-62.62-96.22l-63.13,96.22h-80.95s103.35-147.13,103.35-147.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m588.84,7.13h75.86s0,310.05,0,310.05h123.71s0,66.69,0,66.69h-199.57s0-376.74,0-376.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m816.06,7.13h66.69s0,59.57,0,59.57h-66.69s0-59.57,0-59.57Zm0,97.24h66.69s0,279.5,0,279.5h-66.69s0-279.5,0-279.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m940.39,104.37h62.62c0,12.22,0,23.93-.51,37.16,12.22-21.89,37.17-46.33,87.06-45.82,91.13.51,108.44,70.26,108.44,119.64v168.51s-66.69,0-66.69,0v-151.71c0-41.75-13.75-73.82-60.59-73.82-47.35.51-63.64,32.08-63.64,71.28v154.26s-66.7,0-66.7,0V104.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1256.65,7.13h66.7s0,203.64,0,203.64l96.22-106.4h79.93s-116.07,123.2-116.07,123.2l116.58,156.29h-76.37s-100.29-139.5-100.29-139.5v139.5s-66.7,0-66.7,0V7.13Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBg);
export default __webpack_public_path__ + "static/media/text-bg.2affa5d0bcb81a9c1315eb0d89ecd3b9.svg";
export { ForwardRef as ReactComponent };